module.exports = __webpack_public_path__ + "img/Kashy.a308d7a3.png";